import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { BranchDetails } from "./Branches/BranchDetails";
import { BranchesTable } from "./Branches/BranchesTable";

export const BranchesTab = (props) => {
    const {applicationType, isArchiveApplication} = props
    const additionalBranchApplications = useSelector(state => state.additionalApplications.additionalBranchApplications)
    
    const additionalBranches = useMemo(() => {
        const arr = []
        additionalBranchApplications.forEach(additionalBranchApplication => {
            if(!additionalBranchApplication?.markedDoNotRenew) {
                const branches = additionalBranchApplication?.businessLicenceData?.additionalBranches ?? []
                arr.push(...branches.map(b => ({...b,branchApplicationId : additionalBranchApplication.id})))
            }
        })
        return arr;
    }, [additionalBranchApplications])

    const [branch, setBranch] = useState()

    return branch ? 
    <BranchDetails 
        branch={branch} 
        setBranch={setBranch} 
        applicationType = {applicationType}
        isArchiveApplication = {isArchiveApplication}
    />
    : <BranchesTable additionalBranches={additionalBranches} setBranch={setBranch} />
}
